module.exports = __webpack_public_path__ + "static/media/location_widget.c55283f8.jpg";